import { AppLayout } from "../shared";
import SubOrgs from "../SubOrgs/SubOrgs";

const SubOrgs_layout = ({ props, setIsLoaded }) => {
  return (
    <AppLayout props={props}>
      <SubOrgs props={props} setIsLoaded={setIsLoaded} />
    </AppLayout>
  );
};

export default SubOrgs_layout;
